$(function () {
  $('.homeMovie__more').on('click', function () {
    $('.homeMovie__moreBody.is_no_disp').slideToggle();
    if ($(this).hasClass('is_open')) {
      $(this).removeClass('is_open');
      $(this).html('MORE');
    } else {
      $(this).addClass('is_open');
      $(this).html('CLOSE');
    }
  });
});
